import { render, staticRenderFns } from "./SignUpFranchisorStepOne.vue?vue&type=template&id=37c763b2&scoped=true&"
import script from "./SignUpFranchisorStepOne.vue?vue&type=script&lang=js&"
export * from "./SignUpFranchisorStepOne.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFranchisorStepOne.vue?vue&type=style&index=0&id=37c763b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c763b2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogoWithTradeMark: require('/home/circleci/repo/components/LogoWithTradeMark.vue').default,VButton: require('/home/circleci/repo/components/VButton.vue').default})
